/**
 * ThemeSelectorSheet
 *
 * Wraps the existing `ThemeSelector` component in a sheet so it can be opened
 * from `UserSettingsPage` (and elsewhere). Selecting a theme updates the saved
 * theme via `ThemeContext` (localStorage `themeMode`).
 */

import { useLocale } from '@/presentation/contexts/LocaleContext';
import { SheetService } from '../service/SheetService';
import { ThemeSelector } from '@/presentation/components/common/ThemeSelector';

const ThemeSelectorTitle = () => {
  const { l10n } = useLocale();
  return <>{l10n.themeSelector.title}</>;
};

export interface ThemeSelectorSheetConfig {
  /** Optional container element, screen key string, or null */
  container?: HTMLElement | string | null;

  /** Optional screen key of the route opening this sheet */
  screenKey?: string;

  /** Force the sheet to render as a dialog instead of a bottom sheet */
  forceDialog?: boolean;
}

const show = (config: ThemeSelectorSheetConfig = {}): Promise<void> => {
  return new Promise((resolve) => {
    SheetService.show({
      title: <ThemeSelectorTitle />,
      content: <ThemeSelector />,
      onClose: resolve,
      closeOnClickOutside: true,
      container: config.container,
      screenKey: config.screenKey,
      forceDialog: config.forceDialog,
      qaId: 'theme-selector',
    });
  });
};

export const ThemeSelectorSheet = {
  show,
};
